/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsThreadColor,
    MelcoModelsThreadColorFromJSON,
    MelcoModelsThreadColorFromJSONTyped,
    MelcoModelsThreadColorToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsColorListItem
 */
export interface MelcoModelsColorListItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsColorListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsColorListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsColorListItem
     */
    code?: string | null;
    /**
     * 
     * @type {MelcoModelsThreadColor}
     * @memberof MelcoModelsColorListItem
     */
    color?: MelcoModelsThreadColor;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsColorListItem
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsColorListItem
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsColorListItem
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsColorListItem
     */
    product_name?: string | null;
}

export function MelcoModelsColorListItemFromJSON(json: any): MelcoModelsColorListItem {
    return MelcoModelsColorListItemFromJSONTyped(json, false);
}

export function MelcoModelsColorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsColorListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'color': !exists(json, 'color') ? undefined : MelcoModelsThreadColorFromJSON(json['color']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'weight': !exists(json, 'weight') ? undefined : json['weight'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
    };
}

export function MelcoModelsColorListItemToJSON(value?: MelcoModelsColorListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'color': MelcoModelsThreadColorToJSON(value.color),
        'type': value.type,
        'weight': value.weight,
        'supplier_name': value.supplier_name,
        'product_name': value.product_name,
    };
}


